import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import PartyDashboard from '../PartyDashboard';
import { getListAPI as getPartyList } from 'components/party/PartyAPI';
import { setPartyList, setPartyDashboardPartyList } from 'store/slice/PharmaSlice';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PartyPageImpl() {
    const dispatch = useDispatch();
    const {partyList} = useSelector((state)=>state.pharmaslice);

    const getPartyListSuccess = (list) =>{dispatch(setPartyList(list));}
    useEffect(() => {
        dispatch(openDrawer({drawerOpen: true}));
        getPartyList(()=>{}, getPartyListSuccess);
    },[]);
    useEffect(()=>{
        setPartyDashboardPartyList(partyList);
    },[ partyList])

    return (
        < PartyDashboard />
    )

}